import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import _ from "lodash";

import WaitingTimePerService from "../../components/organization/reports/WaitingTimePerService";
import { getReportDescription } from "../../store/helpers";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const WaitingTimePerServicePage = ({

  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;

  const reportTitle = `${reportIndex}. Waiting Time Per Service`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  //requires array of objects
    if (!_.isArray(data)) {
      data = [data];
    }

  return (
    <Box>
      <Box mb="20px">
        <h1>{reportTitle}</h1>
        <p>{getReportDescription(reportRange).WaitingTimePerServiceBranches}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data)
        ? data.map((a, index) => {
            return (
              <WaitingTimePerService
                key={index}
                branchId={a.branchId}
                reportIndex={reportIndex}
                branchIndex={index + 1}
                data={a.servicesData}
                branchName={a.branchName}
                numServices={a.numServices}
              />
            );
          })
        : <Box mt={10}>
              <p>No data available in this report</p>
            </Box>}
    </Box>
  );
};

export default WaitingTimePerServicePage;
